import Logo from "./Logo";
import MobileMenu from "./MobileMenu";
import { useNavigate } from "react-router-dom";

export default function Background({ children }) {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen w-full bg-white text-gray-900 relative overflow-hidden">
      {/* Background image: a slowly turning chart wheel, pinned to the screen
          so it stays centred and visibly moving on long pages. Still for
          readers who ask their device to reduce motion. */}
      <div
        className="pointer-events-none fixed inset-0 animate-spin-slow motion-reduce:animate-none"
        style={{
          transformOrigin: 'center center'
        }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/background.webp')",
            opacity: 0.95,
            transform: 'scale(1.5)',
            width: '100%',
            height: '100%'
          }}
        />
      </div>
      {/* subtle light gradient overlay */}
      <div className="pointer-events-none absolute inset-0"
           style={{
             background:
              "radial-gradient(900px 600px at 20% 20%, rgba(251,146,60,0.08), transparent 60%)," +
              "radial-gradient(900px 600px at 80% 30%, rgba(251,146,60,0.05), transparent 55%)"
           }} />
      
      {/* Mobile Menu */}
      <MobileMenu />
      
      {/* Fixed header, kept slim and opaque so the page doesn't blur
          behind it while scrolling. */}
      <div className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-sm border-b border-gray-200 border-opacity-30 py-1.5 z-10">
        <div className="flex justify-center">
          <Logo showTagline={false} size={36} />
        </div>
      </div>

      {/* content */}
      <div className="relative pt-14">{children}</div>

      {/* Footer scrolls with the page so it doesn't take screen space while reading. */}
      <div className="relative bg-white bg-opacity-90 backdrop-blur-sm border-t border-gray-200 py-4">
        <div className="flex flex-col items-center space-y-1">
          <p className="text-xs text-gray-600 text-center">
            AYUPATH @ Power Pilot Labs - Melbourne Australia
          </p>
          <div className="flex items-center space-x-3">
            <button
              onClick={() => navigate("/privacy")}
              className="text-xs text-orange-600 hover:underline"
            >
              Privacy Policy
            </button>
            <span className="text-xs text-gray-400">|</span>
            <button
              onClick={() => navigate("/terms")}
              className="text-xs text-orange-600 hover:underline"
            >
              Terms of Use
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
